import React, { useState, lazy, Suspense } from 'react'
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    Button,
    CardTitle,
    CardText,
    Row,
    Col,
} from 'reactstrap'
import classnames from 'classnames'
import './Index.css'
import Rooms from '../rooms/index'
import roomImage from '../../../assets/img/navbarIcons/rooms.svg'
import materialImage from '../../../assets/img/navbarIcons/materials.svg'

const Materials = lazy(() => import('../materials/index'))

const Loading = () => {
    return (
        <div
            style={{
                display: 'block',
                textAlign: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                padding: '20px 0',
                color: '#8e8e8e',
            }}
        >
            در حال بارگذاری ...
        </div>
    )
}

const Index = (props) => {
    const [activeTab, setActiveTab] = useState('2')

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab)
    }

    return (
        <div
            className="tools-container h-100"
            style={{ backgroundColor: '#eeeeee' }}
        >
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '1',
                            })}
                            onClick={() => {
                                toggle('1')
                            }}
                        >
                            <img src={materialImage} />
                            پارچه ها
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '2',
                            })}
                            onClick={() => {
                                toggle('2')
                            }}
                        >
                            <img src={roomImage} />
                            اتاق ها
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent
                    style={{
                        height: 'calc(100vh - 42px)',
                    }}
                    activeTab={activeTab}
                >
                    <TabPane tabId="1">
                        <Row className="tools-row">
                            {activeTab === '1' && (
                                <Suspense fallback={<Loading />}>
                                    <Materials />
                                </Suspense>
                            )}
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row className="tools-row">
                            {activeTab === '2' && (
                                <Suspense fallback={<Loading />}>
                                    <Rooms />
                                </Suspense>
                            )}
                        </Row>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default Index
